import { useNavigate } from 'react-router-dom'

export default function QuickActions() {
  useNavigate() // retained for potential future navigation; suppress unused lint
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <button className="btn-primary w-full py-5 sm:py-6" onClick={() => {
        const el = document.getElementById('feeling-lucky')
        el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }} aria-label="Feeling Lucky quick action">Feeling Lucky</button>
      <button className="btn-nav w-full py-5 sm:py-6" onClick={() => {
        const el = document.getElementById('create-plan')
        el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }} aria-label="Create Date Plan quick action">Create Date Plan</button>
      <button className="btn-nav w-full py-5 sm:py-6" onClick={() => {
        const el = document.getElementById('partners-section')
        el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }} aria-label="Manage partners quick action">Manage Partners</button>
    </div>
  )
}


